import { CashDeskFragment, FiscalType } from 'src/api/api.generated'

export function isCashDeskDisabled(cashDesk: CashDeskFragment, fiscalType: FiscalType | undefined): boolean {
  return fiscalType != undefined && fiscalType != null && !cashDesk.cashDeskType.documentsActive.map((da) => da.fiscalType).includes(fiscalType)
}

/**
 * Check the resource types subset is contained into a resource types set
 * @param resourceTypesSubset the subset to check
 * @param resourceTypesSet the set
 * @returns true if subset is completly contained
 */
export function isResourceTypesSubset(resourceTypesSubset: string[], resourceTypesSet: string[]) {
  return resourceTypesSubset.every((crt) => resourceTypesSet.includes(crt))
}
